<template>
  <div
    class="CampusRank-wrap"
    v-loading="loading.area"
  >
    <div class="Dashboard-title">各区域消费占比</div>
    <CampusRankChart
      :data="campusRankListFillAreaname"
      :changeCampusHandle="changeCampusHandle"
      :updateCampusName="updateCampusName"
      :showOtherNameHandle="showOtherNameHandle"
    />
    <div class="SeviceRatio-title">{{showOther?'其他校区':areaInfo.areaName}}</div>
  </div>
</template>

<script>
import CampusRankChart from './CampusRankChart';
import { mapGetters, mapActions } from 'vuex';
import AreaDashboardMixin from '../../../components/input/AreaDashboard/mixin';

export default {
  name: 'CampusRank',
  components: { CampusRankChart },
  mixins: [AreaDashboardMixin],
  computed: {
    ...mapGetters('Dashboard', [
      'campusRankList',
      'filters',
      'areaInfo',
      'loading',
    ]),
    campusRankListFillAreaname() {
      return this.campusRankList.map(item => {
        if (item.areaName) {
          return item;
        } else {
          let areaName = this.getAreaName(item.areaId);
          return {
            ...item,
            areaName: areaName,
          };
        }
      });
    },
  },
  data() {
    return { showOther: false };
  },
  methods: {
    ...mapActions('Dashboard', [
      'fetchConsumeList',
      'updateCampusName',
      'updateFilters',
    ]),
    changeFilterHandle(data) {
      this.updateFilters(data);
      this.fetchConsumeList();
    },
    changeCampusHandle(data) {
      this.fetchConsumeList({
        areaId: data.areaId,
        updatePercentList: true,
      }).then(() => {
        this.updateCampusName(data);
        this.showOther = false;
      });
    },
    changeOperatorHandle(data) {
      this.updateFilters({ ...data, choiceareaIds: [] });
      // this.fetchConsumeList();
    },
    showOtherNameHandle() {
      this.showOther = true;
    },
  },
};
</script>

<style lang="scss">
.CampusRank-wrap {
  .CampusRank-search {
    margin-right: 5px;
  }
}
</style>
